@if (activity | activityAsToDoItem; as toDoItem) {
    <div class="d-flex align-items-center" data-cy="activity-header">
        @if (showResponsiveBackButton) {
            <div class="d-block d-lg-none">
                <atom-icon-button
                    class="me-2"
                    btnClass="btn-ghost"
                    icon="chevron-left"
                    size="sm"
                    (click)="onBackClicked($event)"
                ></atom-icon-button>
            </div>
        }
        <div class="text-truncate">
            <div class="d-flex align-items-center">
                <div
                    class="flex-grow-1 d-flex align-items-center text-truncate"
                >
                    <wdx-icon
                        class="me-2 icon-shift-up"
                        [icon]="
                            ACTIVITY_ICON_MAP[
                                toDoItem?.data.activity.activityType
                            ]
                        "
                    ></wdx-icon>
                    <div class="d-flex align-items-baseline min-w-0">
                        <h5
                            class="mb-0 text-truncate"
                            data-cy="lbl-activity-subject"
                            [title]="toDoItem?.data.activity.subject"
                        >
                            {{ toDoItem?.data.activity.subject }}
                        </h5>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center mt-1">
                <div class="divider-end divider--short">
                    <molecule-avatar-group
                        size="sm"
                        [avatars]="toDoItem?.avatars"
                        [onMutedBg]="true"
                    ></molecule-avatar-group>
                </div>
                <div class="divider-end divider--short text-truncate">
                    @if (
                        toDoItem.filedUnder?.length &&
                        toDoItem.filedUnder?.length >= 1
                    ) {
                        <div
                            class="to-do-card__filed-under d-flex align-items-center mt-1"
                            data-cy="card-to-do"
                        >
                            <wdx-icon
                                class="me-1 d-flex justify-content-center align-items-center"
                                icon="folder-open"
                            ></wdx-icon>
                            @if (
                                toDoItem.filedUnder[0].data?.id;
                                as fileUnderId
                            ) {
                                @if (fileUnderId === entityId) {
                                    <span class="small">
                                        {{ toDoItem.filedUnder[0].label }}
                                    </span>
                                }
                                @if (fileUnderId !== entityId) {
                                    <a
                                        class="fw-normal small text-truncate"
                                        [routerLink]="
                                            toDoItem.filedUnder[0].data?.type
                                                | entityRoute
                                                    : toDoItem.filedUnder[0]
                                                          .data?.id
                                        "
                                        [title]="
                                            toDoItem.filedUnder[0].label
                                                | translateTokenisedString
                                        "
                                    >
                                        {{
                                            toDoItem.filedUnder[0].label
                                                | translateTokenisedString
                                        }}
                                    </a>
                                }
                            }
                            @if (toDoItem.filedUnder.length > 1) {
                                <div class="ms-1 small">
                                    <span
                                        >+{{
                                            toDoItem.filedUnder.length - 1
                                        }}&nbsp;{{
                                            MORE_LABEL
                                                | translateTokenisedString
                                        }}</span
                                    >
                                </div>
                            }
                        </div>
                    }
                    @if (!toDoItem.filedUnder?.length) {
                        <div
                            class="d-flex align-items-center small my-2 align-self-end"
                        >
                            <wdx-icon
                                class="me-1 justify-content-center align-items-center"
                                icon="triangle-exclamation"
                            ></wdx-icon>
                            <div class="text-nowrap">
                                {{ NOT_FILED | translateTokenisedString }}
                            </div>
                        </div>
                    }
                </div>
                @if (toDoItem.attachments) {
                    <div class="divider-end divider--short">
                        <div
                            class="to-do-card__tertiary-info__attachments d-flex align-items-center"
                        >
                            <wdx-icon
                                class="me-1 justify-content-center align-items-center"
                                icon="paperclip"
                            ></wdx-icon>
                            <span class="small">{{
                                toDoItem.attachments
                            }}</span>
                        </div>
                    </div>
                }
                <div
                    class="d-flex align-items-center divider-end divider--short"
                >
                    <clmi-comment-button
                        data-cy="btn-comment"
                        [entityId]="toDoItem?.data.activity.id"
                        [activityType]="toDoItem?.data?.activity?.activityType"
                        [count]="toDoItem?.commentCount"
                        [hasIssue]="toDoItem?.hasIssue"
                        [modalTitle]="toDoItem?.data.activity.subject"
                    ></clmi-comment-button>
                </div>
                <div
                    class="divider--short"
                    data-cy="a-status"
                    [class.divider-end]="toDoItem?.dueDate"
                >
                    <clmi-activity-status-tag
                        class="mt-1 align-self-end"
                        [activity]="activity"
                    ></clmi-activity-status-tag>
                </div>
                @if (canEdit$ | ngrxPush) {
                    <input
                        ngbDatepicker
                        #dueDatePicker="ngbDatepicker"
                        type="text"
                        datepickerClass="datepicker"
                        class="visually-hidden"
                        [minDate]="minDueDate"
                        [maxDate]="maxDueDate"
                        [startDate]="startDueDate"
                        (dateSelect)="onDueDatePickerSelected($event)"
                    />
                    <button
                        data-cy="btn-activity-due-date"
                        class="btn btn-link text-nowrap me-2 d-flex align-items-center"
                        wdxStopPropagation
                        click-prevent-default
                        (click)="onDueDateClicked(dueDatePicker)"
                    >
                        <wdx-icon
                            class="me-1 text-muted"
                            [icon]="activity | activityDateIcon"
                            size="fit"
                        ></wdx-icon>
                        {{ activity | activityDateValue }}
                    </button>
                } @else {
                    <div
                        data-cy="btn-activity-due-date"
                        class="d-flex align-items-center text-nowrap fw-bold"
                    >
                        <wdx-icon
                            class="me-1 text-muted"
                            [icon]="activity | activityDateIcon"
                            size="fit"
                        ></wdx-icon>
                        <span>{{ activity | activityDateValue }}</span>
                    </div>
                }
            </div>
        </div>
    </div>
}
